/**=========================================================
 * Module: table.js
 * Table Controller
 =========================================================*/

App.controller('TableController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', '$filter', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, $filter, D) {
    "use strict";

    //inizializzazione dati
    let locationAction = $state.params.action
    let locationType = $state.params.type
    let range = $scope.range || ($scope.table && $scope.table.range) || 50

    
    
    $scope.pages = 0
    $scope.loading = false
    $scope.currentFilter = {}
    let startAtPages = [];
    $scope.locationhref = window.location.href;

    let getActionFromLocation = function(){
        return window.location.href.split('/')[5]
    }
    let getTypeFromLocation = function(){
        return window.location.href.split('/')[6]
    }
    //evento cambio history
    //se cambia solo la query string aggiorna i filtri
    //se cambia pagina deve resettare i filtri
    let onPopstate = function (event) {
        if(getActionFromLocation()==locationAction && getTypeFromLocation()==locationType){
            $scope.locationhref = event.target.location.href
            updateFilterOnUrlChange()
        } else {
            $scope.currentFilter = {}
            $scope.table.currentPage = 0
            $scope.pages = 0
        }
    }

    let rootScopeEventListeners = []
    
    //al cambio della variabile table aggiorna i filtri
    $scope.$watch('table', function(newValue, oldValue) {
        if($scope.table && $scope.table.fields && !$scope.preload){
            if($scope.table.range!==undefined) { range = $scope.table.range }
            //L.log('TABLE: init')
            $scope.currentFilter = {}
            $scope.table.availableFields = $scope.table.fields.filter(function(f){ return f.available; })
            window.addEventListener('popstate', onPopstate);
            $scope.table.currentPage = 0
            $timeout(function(){          
                $scope.locationhref = window.location.href
                updateFilterOnUrlChange(true)
            }, 500)
        }
    });


    //reset filtri
    $scope.clearAllFilters = function($event){
        //L.log('TABLE: clearAllFilters')
        if($scope.table && $scope.table.fields){
            for(var i=0; i<$scope.table.fields.length; i++){
                if($scope.table.fields[i].filterValue){
                    $scope.table.fields[i].filterValue = ''
                }
                if($scope.table.fields[i].filterValueArray && $scope.table.fields[i].filterValueArray.length){
                    $scope.table.fields[i].filterValueArray = []
                }
            }
            $scope.table.currentPage = 0
            $scope.updateFilter($event, true)
        }
    }

    //evento filtro aggiornato => applica filtro
    //chiamato dagli eventi degli input (normalmente con force = false tranne alcuni) o dalla reset filtri (con force = true)
    $scope.updateFilter = function($event, force, resetField){
        if(force===true && $event && $event.preventDefault) { $event.preventDefault() }
        if(force===true || $event.keyCode==13){
            //L.log('TABLE: updateFilter')
            if(resetField){
                resetField.filterValue = ''
                resetField.filterValueArray = null
            }
            applyFilter()
        }
    }

    //campo filtro cambiato
    $scope.filterFieldChanged = function(field){
        //L.log('TABLE: filterFieldChanged')
        field.status = 'changedinput'
    }

    //filtro corrente più pagina corrente
    let getCurrentFilterAndPage = function(){
        let currentFilterAndPage = Object.assign({}, $scope.currentFilter, { _page: $scope.table.currentPage || '' })
        return currentFilterAndPage
    }

    //modifica dell'url
    //chiamata da applyFilter
    //aggiunge i parametri di filtro all'url insieme a _page
    //se il filtro è vuoto rimuove il parametro dall'url
    //se l'url è cambiata modifica l'history
    let changeUrl = function(){
        let replaceQueryString = function(url, param, value) {
            var re = new RegExp("([?|&])" + param + "=.*?(&|$)", "i");
            //var re = new RegExp("([?|&|/])" + param + "=.*?(&|$)", "i");
            if (url.match(re))
                return url.replace(re, '$1' + param + "=" + value + '$2');
            else{
                if(url.indexOf('?')<0){
                    return url + '?' + param + "=" + value;
                //if(url.charAt(url.length-1)=='/'){
                //    return url + param + "=" + value;
                } else {
                    return url + '&' + param + "=" + value;
                }
            }
        }
        let removeNullParam = function(url, key){
            url = url.replace('?'+key+'=&','?')
            url = url.replace('?'+key+'=','?')
            //url = url.replace('/'+key+'=&','/')
            //url = url.replace('/'+key+'=','/')
            url = url.replace('&'+key+'=','')
            if(url.indexOf('?', url.length - '?'.length) !== -1) url = url.substr(0, url.length-1)
            return url
        }

        var url = ''+window.location.href
        let queryObj = parseQuery(url)
        for(var key of Object.keys(queryObj)){
            if(key.startsWith('__')){
                $scope.currentFilter[key.substring(2)] = queryObj[key]
                url = url.replace('?' + key + '=' + queryObj[key] + '&', '?')
                    .replace('?' + key + '=' + queryObj[key], '')
                    .replace('&' + key + '=' + queryObj[key], '')
            }
        }
        let currentFilterAndPage = getCurrentFilterAndPage()
        for(var key in currentFilterAndPage){
            url = replaceQueryString(url, key, currentFilterAndPage[key])
            if(currentFilterAndPage[key]===''){
                url = removeNullParam(url, key)    
            }
        }
        if(url!=window.location.href){
            $scope.$parent.page.subTitle = printFilter()
            $scope.locationhref = url
            window.history.pushState(currentFilterAndPage, '', url)
        }
    }
    
    let updatechosen = function(f){
        $timeout(function(){
            //$('#filter-container-' + f.name + ' .chosen-select').val(f.filterValueArray)
            $('#filter-container-' + f.name + ' .chosen-select').trigger('chosen:updated')
        }, 1000)
    }

    let parseQuery =function(href) {
        let queryString = href.substr(href.indexOf('?')+1)
        if(href.indexOf('?')<0) queryString = ''
        //let queryString = getFilterFromLocation(href)
        var query = {};
        if(!queryString) return query
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }

    //applica il filtro se cambia l'url o se caricata table
    //prende i parametri di filtro dall'url
    let updateFilterOnUrlChange = function(changeCurrentFilter){

        if($scope.table && $scope.table.fields){
            //L.log('TABLE: updateFilterOnUrlChange')
            var q = parseQuery($scope.locationhref)
            if(changeCurrentFilter){
                $scope.currentFilter = q
            }
            for(var i=0, l=$scope.table.fields.length; i<l; i++){
                $scope.table.fields[i].filterValue = ''
                for(var key in q){
                    if($scope.table.fields[i].name==key){
                        $scope.table.fields[i].filterValue = q[key]
                        if(q[key] && typeof q[key] == 'string' && $scope.table.fields[i].filterType=='multilanguage'){ //unico campo con filterValueArray, aggiungerne altri se necessario
                            $scope.table.fields[i].filterValueArray = q[key].split(' ')
                            $scope.table.fields[i].filterValue = ''
                        } else {
                            $scope.table.fields[i].filterValueArray = null
                        }
                        if(changeCurrentFilter){
                            $scope.currentFilter[key] = q[key]
                        }
                    } else if(key=='_page'){
                        $scope.table.currentPage = q[key]
                    }
                    if($scope.table.fields[i].filterType=='multilanguage'){
                        updatechosen($scope.table.fields[i])
                    }
                }
            }
            applyFilter()
            $scope.$parent.page.subTitle = printFilter()
        }
    }

    let transformLanguageString = function(str) {
        const parts = str.split('_');
        
        if (parts.length === 2) {
            // Se ha un solo underscore
            return parts[0] + '_' + parts[1].toUpperCase();
        } else if (parts.length === 3) {
            // Se ha due underscore
            const firstPart = parts[0];
            const secondPart = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
            const thirdPart = parts[2].toUpperCase();
            return firstPart + '_' + secondPart + '_' + thirdPart;
        } else {
            // Se non ha underscore o ne ha più di due, restituisce la stringa originale
            return str;
        }
    }

    let printFilter = function(){
        let pf = ''
        try{
            for(var i=0, l=$scope.table.fields.length; i<l; i++){
                if($scope.table.fields[i].filterValue || ($scope.table.fields[i].filterValueArray && $scope.table.fields[i].filterValueArray.length)){
                    let field = $scope.table.fields[i]
                    let filterType = field.filterType
                    if(pf) pf += '; '
                    pf += $filter('translate')(field.customLabel || ('fields.' + (field.label || field.name).toUpperCase())) + ': ' 
                    switch(filterType){
                        case 'select': pf += $filter('translate')(field.filterOptions.filter(o => o.value.toUpperCase()==field.filterValue.toUpperCase())[0].label); break;
                        case 'multilanguage': for(var j=0, m=field.filterValueArray.length; j<m; j++){ pf += (j>0 ? ', ' : '') + $filter('translate')('enums.language.' + transformLanguageString(field.filterValueArray[j])); } break;
                        case 'language': pf += $filter('translate')('enums.language.' + transformLanguageString(field.filterValue)); break;
                        case 'clients': pf += $rootScope.clients.filter(c => c.id==field.filterValue)[0].name; break;
                        case 'owners': pf += $rootScope.owners.filter(o => o.id==field.filterValue)[0].name; break;
                        case 'suppliers': pf += $rootScope.suppliers.filter(s => s.id==field.filterValue)[0].name; break;
                        case 'admins': pf += $rootScope.admins.filter(a => a.id==field.filterValue)[0].name; break;
                        case 'date': pf += $filter('display')(field.filterValue, {type:'date'}); break;
                        default: pf += field.filterValue; break;
                    }
                }
            }
        } catch(e) {}
        return pf
    }

    $scope.hasValueInFilter = false;
    let applyFilter = function(cursor){
        
        let fields = $scope.table.fields;
        $scope.hasValueInFilter = false;
        for(var i=0, l=$scope.table.fields.length; i<l; i++){
            var f = fields[i];
            f.status = ''
            var fv = Array.isArray(f.filterValue) || (f.filterValueArray && f.filterValueArray.length) ? 
                (Array.isArray(f.filterValue) && f.filterValue.join(' ').toLowerCase()) || f.filterValueArray.join(' ').toLowerCase() 
                : 
                (f.filterValue instanceof Date ? f.filterValue.getTime() : (f.filterValue || '').toLowerCase());
            if(fv) $scope.hasValueInFilter = true;
            f.filterValueLC = fv;
            let hasChanged = $scope.currentFilter[f.name]!==undefined && $scope.currentFilter[f.name]!==fv
            if((fv!=='') || (hasChanged)){
                if(fv){
                    f.status = 'applied'
                    f.mo = false
                }
            }
            if(hasChanged){
                startAtPages = []
                $scope.table.currentPage = 0
            }
            if(fv=='' && !f.status=='changedinput') f.status = ''
            $scope.currentFilter[f.name] = fv;
        }
        changeUrl()
        
        //currentFilter from object to querystring
        let currentFilterQuery = '';
        let currentFilterAndPage = getCurrentFilterAndPage()
        for(let key in currentFilterAndPage){
            if(currentFilterAndPage[key]!=='' && currentFilterAndPage[key]!==undefined && currentFilterAndPage[key]!==null){
                currentFilterQuery += '&'+key+'='+currentFilterAndPage[key]
            }
        }
        
        $scope.load(currentFilterQuery, cursor)
        
    }

    

    $scope.changePagination = function(page){
        //L.log('TABLE: changePagination')
        let cursor = ''
        if(startAtPages[page]){
            cursor = startAtPages[page]
        } 
        $scope.table.currentPage = page;
        applyFilter(cursor);
    }

    let constructFilter = function(filter, cursor){
        //L.log('TABLE: constructFilter')
        let result = { filter: '', withCount: false };
        if($scope.table.baseFilter){
            if(filter) filter += '&';
            filter += $scope.table.baseFilter;
        }
        let addCount = false;
        if($scope.filterQuery!=filter){
            addCount = true;
        }
        $scope.filterQuery = filter;
        if(addCount) {
            result.withCount = true;
            addCount = false;
            $scope.table.count = null;
            $scope.table.pages = null;
        }
        if(cursor) {
            if(filter) filter += '&';
            filter += '_cursor='+cursor;
        } else {
            if($scope.table.currentPage) {
                if(filter) filter += '&';
                filter += '_page='+$scope.table.currentPage;
            }
        }
        if(filter) filter += '&';
        filter += '_range=' + range;
        result.filter = filter;
        return result
    }

    let onResponse = function(response, loadMore){
        $scope.data = response

        $scope.table.data = $scope.data

        if($scope.table.loadCallback) {
            $scope.table.loadCallback($scope)
        }

        $scope.table.currentPage = $scope.table.currentPage || 0;
        let start = range>0 ? $scope.table.currentPage * range + 1 : 1;
        $scope.table.dataInterval = start + '-' + (start + $scope.data.length - 1);
        $scope.lastCursor = response.cursor;

        

        if(response.length==range) {
            startAtPages[$scope.table.currentPage+1] = $scope.data[$scope.data.length-1].id;
        }
        //L.log('TABLE: onResponse', $scope.table)
        if(loadMore) {
            D.stream($scope.table.type, constructFilter(filter, $scope.lastCursor).filter, (resp) => { onResponse(resp, false) }, 0)
        }
    }

    function tableStatus(loading){
        try{
            if(loading){
                $timeout(function(){
                    $scope.table.loading = true;
                    $scope.table.finished = false;
                }, 10)
                window.document.getElementById('table-body').style.opacity = 0.8
                window.document.getElementById('updating-filter').style.display = 'inline'
            } else {
                $timeout(function(){
                    $scope.table.loading = false;
                    $scope.table.finished = true;
                }, 10)
                window.document.getElementById('table-body').style.opacity = 1
                window.document.getElementById('updating-filter').style.display = 'none'
            }
        } catch(e) {
            
        }
    }

    let unwatch = $rootScope.$watch('user.id', function(){
        if($rootScope.user.id){
            updateFilterOnUrlChange()
            unwatch()
        }
    })

    

    $scope.load = function(filter, cursor){
        if(!$rootScope.user.id) return

        let filterResult = constructFilter(filter, cursor);
        filter = filterResult.filter;

        //L.log('TABLE: load', $scope.table)
        
        $scope.filter = filter;
        //$scope.data = [];
        $scope.table.loading = true;

        $scope.table.reload = function(){
            applyFilter()
        }

        if(!$scope.table.type) {
            $scope.error = 'Missing table type';
            $scope.table.loading = false;
            return
        }

        let _loadMore = false;
        if($scope.table.type=='project' && $rootScope.user.groupType=='SUPPLIER' && !$rootScope.user.superUser){
            //_loadMore = true;
        }

        if(filterResult.withCount && !_loadMore) {
            D.query($scope.table.type + ".count", filter).then(function(response){
                //L.log('TABLE: count', $scope.table)
                $timeout(function(){
                    $scope.table.count = response.count;
                    if(range>0){
                        $scope.table.pages = Math.ceil($scope.table.count / range)
                        //startAtPages = new Array($scope.table.pages)
                    }
                }, 10)
            })
        }

        let includedFields = (filter ? '&' : '') + '_fields=' + [... new Set($scope.table.fields.filter(f => f.available).map(f => f.name).concat($scope.table.includedFields ? ',' + $scope.table.includedFields : []))].join(',')

        tableStatus(true)

        D.query($scope.table.type, filter + includedFields, { cache: false }).then(
            function(response){
                
                if(filter == $scope.filter) {
                    onResponse(response, _loadMore)
                }
            },
            function(error){
                $scope.error = error;
                $scope.table.loading = false;
            }
        ).catch(console.error)
        .finally(function(finished){
            if(finished){
                tableStatus(false)
            }
        });
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
        $scope.locationhref = '';
        $scope.currentFilter = {}
        $scope.clearAllFilters()
        window.removeEventListener('popstate', onPopstate)
        for(var i=0; i<rootScopeEventListeners.length; i++){
            rootScopeEventListeners[i]()
        }
    });

  }
  ]);
